import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-performance-summary',
  templateUrl: './performance-summary.component.html',
  styleUrls: ['./performance-summary.component.css']
})
export class PerformanceSummaryComponent implements OnInit {

  @ViewChild('closeModal') private closeModal!: ElementRef;
  @ViewChild('closeAddModal') private closeAddModal!: ElementRef;


  admin_data: any;
  options: any;
  performance_sum = {
    fiscal_year: [] as any, //ปีงบประมาณ
    total_income: [] as any, //รวมรายได้
    total_charge: [] as any, //รวมค่าใช้จ่าย
    highlow_net: [] as any, //รายได้สูง(ต่ำ)กว่าค่าใช้จ่ายสุทธิ
    highlow_cumulative: [] as any //รายได้สูง(ต่ำ)กว่าค่าใช้จ่ายสะสม
  }
  all_performance: any;
  fiscal_year: any;
  year_select: any;
  add_report!: FormGroup;
  edit_report!: FormGroup;

  constructor(
    public services: ApiService,
    public formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    document.getElementById('performancesummary')!.classList.toggle("active");
    this.admin_data = localStorage.getItem("admin_data");
    this.admin_data = JSON.parse(this.admin_data);
    this.getPerformancesum();
    this.fiscal_year = this.services.fiscal_year;
    this.add_report = this.formBuilder.group({
      fiscal_year: '',
      total_income: '',
      total_charge: '',
      previous_error: '',
      user_id: parseInt(this.admin_data.id),
      status: 'Enable'
    });
  }

  ngOnDestroy(){
    document.getElementById('performancesummary')!.classList.remove("active");
  }

  async onSelectYear() {
    let enable_data: any
    await this.services.get('m_performancesum').then(async (res: any) => {

      enable_data = await res.filter((data: any) => {
        return data.status.match('Enable')
      })
      enable_data.forEach((data: any) => {
        if (data.fiscal_year == this.year_select) {
          this.edit_report = this.formBuilder.group({
            id: parseInt(data.id),
            fiscal_year: parseInt(data.fiscal_year),
            total_income: parseFloat(data.total_income),
            total_charge: parseFloat(data.total_charge),
            previous_error: parseFloat(data.previous_error),
            user_id: parseInt(this.admin_data.id),
            status: 'Enable'
          });
        }
      });
    })
  }
  async getPerformancesum() {
    await this.services.get('m_performancesum').then(async (res: any) => {
      this.all_performance = await res.filter((res: any) => {
        return res.status.match('Enable')
      })
      var fiscal_year = [] as any;
      var total_income = [] as any;
      var total_charge = [] as any;
      var highlow_net = [] as any;
      var highlow_cumulative = [] as any;
      var sum = 0;
      this.all_performance = this.all_performance.sort((a: any, b: any) => (a.fiscal_year < b.fiscal_year) ? -1 : ((b.fiscal_year < a.fiscal_year) ? 1 : 0))
      this.all_performance.forEach((data: any) => {
        fiscal_year.push(parseInt(data.fiscal_year))
        total_income.push(parseFloat(data.total_income))
        total_charge.push(parseFloat(data.total_charge))
        highlow_net.push(Math.round((((parseFloat(data.total_income) - parseFloat(data.total_charge))) + Number.EPSILON) * 100) / 100)
        sum += (parseFloat(data.total_income) - parseFloat(data.total_charge))
        sum += parseFloat(data.previous_error)
        highlow_cumulative.push(Math.round(((sum) + Number.EPSILON) * 100) / 100)
        data.highlow_net = Math.round((((parseFloat(data.total_income) - parseFloat(data.total_charge))) + Number.EPSILON) * 100) / 100
        data.highlow_cumulative = Math.round(((sum) + Number.EPSILON) * 100) / 100
      });
      this.performance_sum.fiscal_year = await fiscal_year;
      this.performance_sum.total_income = await total_income;
      this.performance_sum.total_charge = await total_charge;
      this.performance_sum.highlow_net = await highlow_net;
      this.performance_sum.highlow_cumulative = await highlow_cumulative;

      this.options = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#c3bdbd'
            }
          }
        },
        dataZoom: {
          type: 'inside'
        },
        legend: {
          data: ['รวมรายได้', 'รวมค่าใช้จ่าย', 'รายได้สูง(ต่ำ)กว่าค่าใช้จ่ายสุทธิ']
        },
        toolbox: {
          show: true,
          showTitle: false, // hide the default text so they don't overlap each other
          feature: {
            saveAsImage: {
              show: true,
              title: 'บันทึกรูปภาพ'
            },
          }
        },
        xAxis: [
          {
            type: 'category',
            data: this.performance_sum.fiscal_year,
            axisLabel: {
              interval: 0,
              rotate: 1000 //If the label names are too long you can manage this by rotating the label.
            },
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: 'บาท',
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: [
          {
            name: 'รวมรายได้',
            type: 'bar',
            data: this.performance_sum.total_income
          },
          {
            name: 'รวมค่าใช้จ่าย',
            type: 'bar',
            data: this.performance_sum.total_charge
          },
          {
            name: 'รายได้สูง(ต่ำ)กว่าค่าใช้จ่ายสุทธิ',
            type: 'line',
            data: this.performance_sum.highlow_net
          }
        ],
        color: ['#1bcfb4', '#198ae3', '#fed713']
      };
      this.all_performance = this.all_performance.reverse()
    })
  }
  
  onClickAdd() {
    Swal.fire({
      title: 'ยืนยันการบันทึกรายการใหม่',
      icon: 'warning',
      confirmButtonText: `ใช่`,
      denyButtonText: `ไม่ใช่`,
      showDenyButton: true
    }).then((res) => {
      if (res.isConfirmed) {
        this.add_report.value.fiscal_year = parseInt(this.add_report.value.fiscal_year);
        this.services.create('m_performancesum', this.add_report.value).then((res: any) => {
          Swal.fire({
            title: 'บันทึกสำเร็จ',
            icon: 'success',
            confirmButtonText: `ตกลง`
          })
          this.getPerformancesum();
          this.clearForm()
          this.closeAddModal.nativeElement.click();

        })
      } else {
        this.clearForm();
      }
    })
  }
  onClickEdit() {

    Swal.fire({
      title: 'ยืนยันการแก้ไข',
      icon: 'warning',
      confirmButtonText: `ใช่`,
      denyButtonText: `ไม่ใช่`,
      showDenyButton: true
    }).then((res) => {
      if (res.isConfirmed) {
        this.services.update('m_performancesum', parseInt(this.edit_report.value.id), this.edit_report.value).then((res: any) => {
          this.closeModal.nativeElement.click();
          Swal.fire({
            title: 'แก้ไขสำเร็จ',
            icon: 'success',
            confirmButtonText: `ตกลง`
          }).then((res) => {
            this.year_select = '';
            this.getPerformancesum();
            this.clear()
          })
        })
      } else {
        this.year_select = '';
        this.getPerformancesum();
      }
    })

  }
  onClickDelete(data: any) {
    data.status = 'Disable';
    Swal.fire({
      title: 'ยืนยันการลบ',
      icon: 'warning',
      confirmButtonText: `ใช่`,
      denyButtonText: `ไม่ใช่`,
      showDenyButton: true
    }).then((res) => {
      if (res.isConfirmed) {
        this.services.update('m_performancesum', parseInt(data.id), data).then((res: any) => {
          this.closeModal.nativeElement.click();
          Swal.fire({
            title: 'ลบไฟล์สำเร็จ',
            icon: 'success',
            confirmButtonText: `ตกลง`
          }).then((res) => {
            this.year_select = '';
            this.getPerformancesum();
            this.clear()
          })
        })
      }
    })

  }
  clearForm() {
    this.add_report = this.formBuilder.group({
      fiscal_year: '',
      total_income: '',
      total_charge: '',
      high_low: '',
      user_id: parseInt(this.admin_data.id),
      status: 'Enable'
    });
  }
  clear() {
    this.year_select = null;
    this.closeModal.nativeElement.click();
  }
  clickMenu() {
    document.getElementById('sidebar')!.classList.toggle("active");
  }
}
